import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusinessTypeComponent } from './business-type.component';
import { FormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';



@NgModule({
  declarations: [
    BusinessTypeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule
  ], exports:[
    BusinessTypeComponent
  ]
})
export class BusinessTypeModule { }
